
import React from "react";

const PartnerLogos: React.FC = () => {
  // Define our partner logos with names, links and image sources
  const partners = [
    {
      name: "Beatoven.ai",
      link: "https://www.beatoven.ai/",
      logoSrc: "/lovable-uploads/3ea91ecd-352d-4410-b52d-833947f2aadf.png"
    },
    {
      name: "IRCAM Amplify",
      link: "https://go.ircamamplify.io/ai-music-detection-technology",
      logoSrc: "/lovable-uploads/3e72b2d9-a520-4232-8c4f-513df4e6f323.png"
    },
    {
      name: "MTIN",
      link: "#",
      logoSrc: "/lovable-uploads/ae23bc23-78f9-4525-9929-a5b3878de750.png"
    },
    {
      name: "Human Native",
      link: "https://www.humannative.ai/",
      logoSrc: "/lovable-uploads/079edf75-988c-43fa-9bbe-62e82b091c31.png"
    },
    {
      name: "Transparent Audio",
      link: "https://www.transparentaudio.ai/",
      logoSrc: "/lovable-uploads/b7b55eed-e203-4d57-b2d6-2aa4e9aac59b.png"
    },
    {
      name: "AI Transparency Statement",
      link: "https://www.aitransparencystatement.com/",
      logoSrc: "/lovable-uploads/508d8262-4403-46e6-98df-0edd8b9a6d60.png"
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
      {partners.map((partner, index) => (
        <a 
          href={partner.link}
          target="_blank"
          rel="noopener noreferrer"
          key={index}
          className="flex justify-center items-center p-8 bg-gray-50 rounded-lg hover:shadow-md transition-shadow"
        >
          {partner.logoSrc ? (
            <img 
              src={partner.logoSrc} 
              alt={partner.name}
              className="max-h-16 object-contain"
            />
          ) : (
            <div className="text-gray-400 text-center">{partner.name}</div>
          )}
        </a>
      ))}
    </div>
  );
};

export default PartnerLogos;
